// extracted by mini-css-extract-plugin
module.exports = {"desk":"Grid-module_desk_IB6PJ","table":"Grid-module_table_3xd30","actions":"Grid-module_actions_3HYSV","dropdown":"Grid-module_dropdown_3nLam","icon":"Grid-module_icon_2cPwy"};